import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faEdit, faListAlt, faTrash} from "@fortawesome/free-solid-svg-icons";
import MaterialtableDemo from "../../components/plugins/MaterialTableDemo";
import SpinnerLoading from "../../components/Spinners/SpinnerLoading";
import { updateStateModalLarge } from "../../../actions/modalActions";
import ModalBasicwithRedux from "../../../containers/ModalLargewhithRedux";
import FormularioRecurso from './FormularioRecurso';
import "./Trabajadores.scss";

//Reduxt
import {useDispatch, useSelector } from "react-redux";
import { eliminarRecursoCampaign, filtrarRecursos } from "../../../actions/campaignsActions";
import { Button } from "react-bootstrap";
import EditarRecursoC from "./EditarRecurso";
 
const ListaRecursosTab = ({id_proyecto=null}) => {
  //State
  const dispatch = useDispatch();
  const {usuario} = useSelector(state=>state.usuario)
  const {recursos,loading} = useSelector(state=>state.campaigns)

  useEffect(() => {
   dispatch(filtrarRecursos(id_proyecto))
  }, []);

  const handleModalNuevo = () => {
    dispatch(updateStateModalLarge(<FormularioRecurso />, 'Nuevo Recurso'));
  }
  const handleEditar = (registro) => {
    dispatch(updateStateModalLarge(<EditarRecursoC registro={registro} />, 'Editar Recurso'));
  }
  const handleEliminar = (id) =>{
    dispatch(eliminarRecursoCampaign(id,recursos))
  }
  return (
      <div className="Trabajadores">
        <div className="Trabajadores__container">
          <div className="Trabajadores__head">
            <div className="row">
              <div className="col-md-6">

              </div>
              <div className="col-md-6 d-flex justify-content-end align-items-end">
              { usuario.id_tp_nivel_usuario !=='11'? <button className="btn btn-primary" onClick={()=>handleModalNuevo()}> Nuevo Recurso </button>:''}
              </div>
            </div>
          </div>
          <div className="Trabajadores__body container-fluid  px-0 content-actions mt-1">
          <ModalBasicwithRedux />
            <SpinnerLoading loading={loading}>
              <div className="box mt-1">
                <div className="box-header with-border">
                  <h5
                      style={{ color: "#434343" }}
                    >
                    <FontAwesomeIcon icon={faListAlt} /> Lista de Recursos
                  </h5>
                
                </div>
                <div className="box-primary">
                  <MaterialtableDemo
                    colums={colums(handleEliminar,handleEditar,usuario)}
                    tabla={recursos}
                    keyCol="id_recurso"
                  />
                </div>
              </div>
            </SpinnerLoading>
          </div>
        </div>
      </div>
  );
};

export default ListaRecursosTab;

/**====================== TABLA =========== */

const colums = (handleEliminar,handleEditar,usuario) => [
  {
    text: 'ID',
    key: 'id_recurso',
    className: 'id_recurso',
    width: 50
  }
  ,
  {
    text: "Fecha Registro",
    key: "fecha_registro",
    align: "center",
    sortable: true,
    className: "fecha_registro"
  }
  ,
  {
    text: "Nombre Recurso",
    key: "nombre_recurso",
    align: "center",
    sortable: true,
    className: "nombre_recurso",
  },
  {
    text: "Campaña",
    key: "nombre_proyecto",
    align: "center",
    sortable: true,
    className: "nombre_proyecto"
  }
  ,
  {
    text: "Tipo",
    key: "nombre_tipo_r",
    align: "center",
    className: "nombre_tipo_r",
    sortable: true
  }
  ,
  {
    text: "Estado",
    key: "estado",
    align: "center",
    className: "estado",
    sortable: true,
    cell:(record) => record.estado!=="1" ? 'Completado' : 'Idea'
  }
  ,
  {
    text: "URL",
    key: "url_recurso",
    align: "center",
    className: "url_recurso",
    sortable: true,
    cell:(record) => record.url_recurso ? <span style={{display:'inline'}}><a href={record.url_recurso} className='btn btn-info' aria-label='see' target='_blank'><i className='fas fa-link'></i></a></span> : ''
  }
  ,
  {
    text: "Acciones",
    key: "Acciones",
    align: "center",
    className: "Acciones",
    sortable: false,
    cell:(record) => usuario.id_tp_nivel_usuario !=='11'? <p className='text-center'>
    <Button
      variant='warning'
      size='xs'
      type="button"
      onClick={() => handleEditar(record)}
    >
      <FontAwesomeIcon icon={faEdit} />
    </Button>
    <Button
      variant='danger'
      size='xs'
      type="button"
      onClick={() => handleEliminar(record.id_recurso)}
    >
      <FontAwesomeIcon icon={faTrash} />
    </Button>
  </p>:'...'
  }
  
];
